// ─── Document Type Values ───
export type DocumentType = 'purchase_order' | 'grn' | 'grn_return' | string;

export type ruleStatus = 'ACTIVE' | 'INACTIVE';

export interface ruleStatusOption {
  id?: number;
  label: string;
  value: ruleStatus;
}

export interface DocumentTypeOption {
  id: number;
  code: DocumentType;
  name: string;
  description: string;
  display_order: number;
  is_active: boolean;
}

// ─── Approval Level ───

export type ApprovalStatus = 'pending' | 'approved' | 'rejected';

export interface ApprovalLevel {
  role: string;
  roleId: number;
  level: number;
  isMandatory?: boolean;
  status: ApprovalStatus;
  date: string;
}

// ─── Approval Rule Row (matches API object shape) ───
export interface ApprovalRule {
  id: number;
  name: string;
  document_type: number;
  document_type_name: string;
  clinic: number;
  clinic_name: string;
  min_amount: number;
  max_amount: number | null;
  status: ruleStatus;
  priority: number;
  levels_count: number;
  documentType: DocumentTypeOption;
  approvalFlow: ApprovalLevel[];
}

// ─── Approval Rule Level Detail (from GET /approval-rules/:id/) ───
export interface ApprovalRuleLevelDetail {
  id: number;
  level_number: number;
  role: number;
  role_name: string;
  escalation_role: number | null;
  escalation_time_hours: number | null;
  escalation_time_minutes: number | null;
  is_mandatory: boolean;
  skip_if_same_user: boolean;
}

// ─── Approval Rule Detail (single rule GET response) ───
export interface ApprovalRuleDetail {
  id: number;
  name: string;
  document_type: number;
  document_type_name: string;
  documentType: DocumentTypeOption;
  clinic: number;
  clinic_name: string;
  min_amount: string;
  max_amount: string | null;
  status: ruleStatus;
  priority: number;
  is_mandatory: boolean;
  is_email: boolean;
  is_system: boolean;
  levels: ApprovalRuleLevelDetail[];
  approvalFlow: ApprovalLevel[];
  created_on: string;
  updated_on: string;
}

// ─── API list response ───
export interface ApprovalRulesMeta {
  limit: number;
  next: string | null;
  offset: number;
  previous: string | null;
  total_count: number;
}

export interface ApprovalRulesListApiResponse {
  meta: ApprovalRulesMeta;
  objects: ApprovalRule[];
}

// ─── Query params for GET /approval-rules/ ───
export interface ApprovalRulesQueryParams {
  search?: string;
  clinic?: number | null;
  document_type?: number | null;
  status?: ruleStatus | undefined;
  limit?: number;
  offset?: number;
  ordering?: string;
  min_amount_gte?: number;
  max_amount_lte?: number;
}

// ─── Filter Values ───
export interface ApprovalFilterValues {
  documentType: number | null;
  clinicId: number | null;
  status: ruleStatus | '';
}

export const APPROVAL_FILTER_INITIAL_VALUES: ApprovalFilterValues = {
  documentType: null,
  clinicId: null,
  status: '',
};
